export const enum Side {
  Long,
  Short,
}

export type KeyMap<T> = { [key: string]: T };
